/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseDetailResponse } from '../../models/base-detail-response';
import { CreateBaseShiftRequest } from '../../models/create-base-shift-request';

export interface CreateBaseShift$Params {
  id: number;
      body: CreateBaseShiftRequest
}

export function createBaseShift(http: HttpClient, rootUrl: string, params: CreateBaseShift$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseDetailResponse>> {
  const rb = new RequestBuilder(rootUrl, createBaseShift.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseDetailResponse>;
    })
  );
}

createBaseShift.PATH = '/api/scheduler/bases/{id}/shifts';
